import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { InternalUserLandingPageComponent } from './internal-user-landing-page.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [InternalUserLandingPageComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule, 
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    SharedModule      
  ]
})
export class InternalUserLandingPageModule { }
